import { render, staticRenderFns } from "./static-text-widget.vue?vue&type=template&id=76d8e0f2&scoped=true&"
import script from "./static-text-widget.vue?vue&type=script&lang=js&"
export * from "./static-text-widget.vue?vue&type=script&lang=js&"
import style0 from "./static-text-widget.vue?vue&type=style&index=0&id=76d8e0f2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76d8e0f2",
  null
  
)

export default component.exports